import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as GlobalItemCreators } from 'store/ducks/publicGlobal';
import { Box, CircularProgress } from '@material-ui/core';
import appMetrics from 'utils/appMetrics';
import Logo from 'images/logo_black.png';
import ReactMarkdown from 'react-markdown';

const PublicPrivacyPolitiesPage = () => {
  const dispatch = useDispatch();

  const { global, globalLoading } = useSelector(state => state.publicGlobal);

  React.useEffect(() => {
    dispatch(GlobalItemCreators.getGlobalRequest());
  }, []);

  return (
    <Box flex="1">
      {globalLoading && (
        <Box
          flex="1"
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ height: 300 }}
        >
          <CircularProgress style={{ color: appMetrics.PRIMARY_COLOR }} />
        </Box>
      )}

      {!globalLoading && global && (
        <Box>
          <Box
            flex="1"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <img alt="" style={{ marginBottom: 40 }} src={Logo} width={160} />
          </Box>
          <Box
            flex="1"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            POLÍTICAS DE PRIVACIDADE
          </Box>
          <Box
            flex="1"
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{ margin: 50 }}
          >
            <div id="container">
              <ReactMarkdown
                style={{ color: appMetrics.PRIMARY_COLOR, fontSize: 20 }}
                source={global.privacy_policy}
              />
            </div>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PublicPrivacyPolitiesPage;
